import './ProjectListSortLink.scss';
import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';
import { INTEGER_ONE } from 'src/modules/common/constants/integer';
import { ArrowDownIcon } from 'src/modules/common/icons/ArrowDownIcon';
import { ArrowUpIcon } from 'src/modules/common/icons/ArrowUpIcon';
import { BodyMedium01 } from 'src/modules/common/typography/BodyMedium01';
import { ProjectListQuery } from 'src/modules/project-list/types/ProjectListQuery';
import { ProjectListSort } from 'src/modules/project-list/types/ProjectListSort';
import { buildProjectListQuery } from 'src/modules/project-list/utils/query';

type Props = {
  readonly query: ProjectListQuery;
  readonly field: ProjectListSort['field'];
  readonly className?: string;
  readonly children?: React.ReactNode;
};

export const ProjectListSortLink = ({ query, field, className, children }: Props): React.ReactElement => (
  <BodyMedium01
    as={Link}
    to={`?${getSortSearch(query, field)}`}
    className={clsx({ 'bp-project-list-sort-field': true }, className)}
  >
    <span className="bp-project-list-sort-field__title">
      {children}
    </span>

    {query.sort.field === field && (
      <span className="bp-project-list-sort-field__indicator">
        {query.sort.direction === 'asc'
          ? <ArrowUpIcon/>
          : <ArrowDownIcon/>}
      </span>
    )}
  </BodyMedium01>
);

function getSortSearch(query: ProjectListQuery, field: ProjectListSort['field']): string {
  const direction = query.sort.field === field && query.sort.direction === 'asc' ? 'desc' : 'asc';

  return buildProjectListQuery({
    ...query,
    page: INTEGER_ONE,
    sort: { field, direction },
  }).toString();
}
